<template lang="pug">
.badge(:class="color && 'badge-'+color")
  Icon.icn( v-if="icon && icon !== 'none'" :class="icon" :name="icon" :fill="color ? 'white' : 'black'" )
  slot
</template>
<script>
export default {
  name  : 'product-badge',
  props : {
    color: {
      type    : String,
      default : null,
    },
    icon: {
      type    : String,
      default : '',
    },
  },
}
</script>
<style lang="scss" scoped>
.badge {
  display: inline-flex;
  align-items: center;
  font-size: $size-xxs;
  color: $color-black;
  font-weight: $weight-bold;
  margin-right: $space-xxs;
  line-height: 2;

  .icn {
    width: $size-xl;
    height: $size-xl;
    margin-right: $space-xxxs;

    &.shipdeal {
      height: $size-s;
    }
  }

  &.full-width {
    width: 100%;
  }

  &.regular {
    font-weight: $weight-normal;
  }
}

.badge-red, .badge-black, .badge-green {
  background-color: $color-red;
  color: $color-white;
  height: $size-s;
  font-size: 10px;
  line-height: 10px;
  font-weight: $weight-bold;
  padding: $space-xxxs;

  &.badge-green {
    background-color: $color-green-dark;
    margin-bottom: $space-xxs;

    > .icn {
      width: $size-xxs;
      height: $size-xxs;
    }
  }

  &.badge-black {
    background-color: $color-black;
  }

  > .icn {
    width: $size-m;
    height: $size-m;

    &.free-3 {
      width: 15px;
      height: 15px;
    }
  }
}
</style>
